import {
  CustomSiteSettings,
  customSiteSettingsApi,
} from "@/api/customSiteSettings";
import { useReadApi } from "./useReadApi";
import { useContext, useEffect, useMemo } from "react";
import { AuthContext, AuthContextType } from "@/context/AuthContext";
import { hexToHSL } from "@/lib/colors";
import { useTranslation } from "react-i18next";

export const useSiteSettings = () => {
  const { loading, apiResult } = useReadApi<CustomSiteSettings>(
    customSiteSettingsApi,
    "first",
    true,
  );

  return {
    loading,
    apiResult,
  };
};

export const useCustomBranding = () => {
  const { values: contextValues } = useContext(AuthContext) as AuthContextType;
  const { customSiteSettings } = contextValues;
  const { t } = useTranslation();

  const config = useMemo(
    () => ({
      colors: {
        primary: customSiteSettings?.apiResult?.primary_color || "#E47C41",
        secondary: customSiteSettings?.apiResult?.secondary_color || "#F5F5F5",
      },
      logo: customSiteSettings?.apiResult?.logo,
      title:
        customSiteSettings?.apiResult?.title ||
        t("common.statictext.casereview"),
      support_email:
        customSiteSettings?.apiResult?.support_email ||
        "caseconsulting@mindsetintegrated.com",
      co_branding_logo: "/images/home.png",
      dateFormat: customSiteSettings?.apiResult?.date_format || "MM/dd/yyyy",
    }),
    [customSiteSettings, t],
  );

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--primary",
      hexToHSL(config.colors.primary),
    );
    document.documentElement.style.setProperty(
      "--ring",
      hexToHSL(config.colors.primary),
    );
    document.documentElement.style.setProperty(
      "--secondary",
      hexToHSL(config.colors.secondary),
    );
  }, [config]);

  return config;
};
